import * as React from 'react';
import type { MenuData } from "../../../js/data/menuData.ts";
import { getEnv } from "../../js/helpers/env.ts";
import LogoFooter from "./logoFooter.tsx";
import MenuItem, { filterMenuItemsByParent } from "./menuItem.tsx";

type Props = {
	menu: MenuData,
	pathname: string,
}

const Footer = ({menu, pathname, ...otherProps}: Props) => {

	const rootMenuItems = filterMenuItemsByParent(menu, null);

	return (<>
		<div id="footerWrapper" className="bg-black text-white pt-12 md:pt-16 pb-12 text-sm">
			<footer className="max-w-screen-2xl mx-auto px-8 md:px-20 xl:px-30">

				<div className="flex flex-wrap lg:flex-nowrap justify-stretch items-start gap-8 mb-12 lg:mb-20">

					<div className="w-full lg:w-1/3 justify-center lg:justify-start order-1">
						<ul className="menuFooter list-none m-0 pl-0 text-center lg:text-left">
							{rootMenuItems?.map((item, index) => {
								return <MenuItem
									menu={menu}
									item={item}
									key={'item' + index}
									pathname={pathname}
									index={index}
									siblingsCount={rootMenuItems.length - 1}
									className="mb-3"
								/>;
							})}
						</ul>
					</div>

					<div className="w-full lg:w-1/3 flex justify-center order-3 lg:order-2 mt-20 lg:mt-0">
						<div>
							<div className="logo"/>
						</div>
					</div>

					<div className="w-full lg:w-1/3 flex justify-center lg:justify-end order-2 lg:order-3">
						<div>
							<div className="text-center lg:text-left mb-8">
								<div className="flex justify-center lg:justify-end gap-8">
									<a href="https://www.facebook.com/share/1B9Z949DvB/?mibextid=wwXIfr" target="_blank">
										<img src="/images/logo/logo_fb.svg" alt="Facebook" width="25" height="24"/>
									</a>
									<a href="https://www.instagram.com/niftydental?igsh=MTZpbXFxdGFyN3p5ag%3D%3D&utm_source=qr" target="_blank">
										<img src="/images/logo/logo_in.svg" alt="Linked In" width="25" height="24"/>
									</a>
									<a href="https://www.instagram.com/niftydental?igsh=MTZpbXFxdGFyN3p5ag%3D%3D&utm_source=qr" target="_blank">
										<img src="/images/logo/logo_insta.svg" alt="Instagram" width="24" height="24"/>
									</a>
								</div>
							</div>
							<div className="text-center lg:text-left">
								<div className="flex justify-between gap-8">
									<img src="/images/footer/DS_Core.png" alt="" width="61" height="52"/>
									<img src="/images/footer/DLA_logo.png" alt="" width="126" height="53"/>
									<img src="/images/footer/CERTIFIED_LAB.png" alt="" width="61" height="62"/>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="w-full flex flex-wrap items-center justify-center lg:justify-between text-xs font-light border-t border-white py-6 tracking-wider gap-8">
					<div className="text-center lg:text-left">
						&copy; {new Date().getFullYear()} <>{getEnv('PUBLIC_FULL_COMPANY_NAME')}</> | Company registered in England and Wales (15827921) | Richmond Hill Farm, Chiselhampton, Oxford OX44 7XF
					</div>
					<div className="text-center lg:text-right">DESIGNED BY HALLO DIGITAL</div>
				</div>
			</footer>
		</div>
	</>);
}

export default Footer;
